var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxBoldColorsSquare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.81 2C4.17 2 2 4.17 2 7.81v8.37C2 19.83 4.17 22 7.81 22h8.37c3.64 0 5.81-2.17 5.81-5.81V7.81C22 4.17 19.83 2 16.19 2H7.81zm7.79 7.6c0 .47-.09.92-.25 1.33A3.61 3.61 0 0 1 12 13.21c-.33 0-.65-.04-.95-.13A3.587 3.587 0 0 1 8.4 9.6C8.4 7.61 10.01 6 12 6s3.6 1.61 3.6 3.6zM6 14.4c0-1.34.74-2.51 1.82-3.13.52 1.31 1.64 2.3 2.99 2.66.38.11.77.16 1.19.16.41 0 .79-.05 1.16-.15.02.14.04.3.04.45 0 1.06-.46 2.02-1.2 2.68-.64.58-1.48.93-2.4.93C7.61 18 6 16.39 6 14.4zm6.75 3.2c.86-.83 1.35-1.99 1.35-3.2 0-.2-.02-.41-.05-.6a.321.321 0 0 1 .122-.305c1.077-.827 1.743-1.569 1.998-2.225 1.09.62 1.83 1.79 1.83 3.13 0 1.99-1.61 3.6-3.6 3.6-.59 0-1.16-.14-1.65-.4z",
    fill: "{props.color}",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxBoldColorsSquare);
export default __webpack_public_path__ + "static/media/vuesax-bold-colors-square.829073aad3acb257a26c937d17562a3c.svg";
export { ForwardRef as ReactComponent };